import React from 'react';

const CircleIcon = ({ size = 50, color = "black" }) => (
  <svg height={size} width={size}>
    <circle cx={size/2} cy={size/2} r={size/2 - 3} stroke={color} strokeWidth="2" fill="transparent" />
  </svg>
);

export default CircleIcon;
